import { useQuery } from "@apollo/client/react";
import { Navigate, Route, Routes } from "react-router";
import { GetCurrentLoggedUserDocument } from "./gql/generated/graphqlSchema.tsx";
import { routes } from "./routes.ts";
import { LandingPage } from "./pages/landing/LandingPage.tsx";
import { ImpressumPage } from "./pages/legal/ImpressumPage.tsx";
import { PrivacyPage } from "./pages/legal/PrivacyPage.tsx";
import { TermsPage } from "./pages/legal/TermsPage.tsx";
import { LoginPage } from "./pages/login/LoginPage.tsx";
import { VerifyEmailLinkPage } from "./pages/auth/VerifyEmailLinkPage.tsx";
import { MyAccountPage } from "./pages/settings/MyAccountPage.tsx";
import { ProducersPage } from "./pages/producer/ProducersPage.tsx";
import { ProducerDetailEditPage, ProducerDetailPage } from "./pages/producer/ProducerDetailPage.tsx";
import { RecipesPage } from "./pages/recipe/RecipesPage.tsx";
import { RecipeDetailEditPage, RecipeDetailPage } from "./pages/recipe/RecipeDetailPage.tsx";
import { RecipeDetailVersionPage } from "./pages/recipe/RecipeDetailVersionPage.tsx";
import { IngredientsPage } from "./pages/ingredient/IngredientsPage.tsx";
import { IngredientDetailEditPage, IngredientDetailPage } from "./pages/ingredient/IngredientDetailPage.tsx";
import { IngredientDetailVersionPage } from "./pages/ingredient/IngredientDetailVersionPage.tsx";
import { PhoneUploadPage } from "./pages/phone/PhoneUploadPage.tsx";
import { AuthenticatedRoutes } from "./routes/AuthenticatedRoutes.tsx";
import { GuestRoutes } from "./routes/GuestRoutes.tsx";

export const App = () => {
  const { data, loading } = useQuery(GetCurrentLoggedUserDocument);

  return (
    <Routes>
      <Route
        element={<LandingPage authLoading={loading} currentLoggedUser={data?.getCurrentLoggedUser} />}
        path={routes.landing.path}
      />
      <Route element={<ImpressumPage />} path={routes.legal.path} />
      <Route element={<PrivacyPage />} path={routes.privacy.path} />
      <Route element={<TermsPage />} path={routes.terms.path} />
      <Route element={<GuestRoutes />}>
        <Route element={<LoginPage />} path={routes.login.path} />
      </Route>
      <Route element={<AuthenticatedRoutes />}>
        <Route element={<MyAccountPage />} path={routes.myAccount.path} />
        <Route element={<ProducersPage />} path={routes.producers.path} />
        <Route element={<ProducerDetailEditPage />} path={routes.producerDetailEdit.path} />
        <Route element={<ProducerDetailPage />} path={routes.producerDetail.path} />
        <Route element={<RecipesPage />} path={routes.recipes.path} />
        <Route element={<RecipeDetailVersionPage />} path={routes.recipeDetailVersion.path} />
        <Route element={<RecipeDetailEditPage />} path={routes.recipeDetailEdit.path} />
        <Route element={<RecipeDetailPage />} path={routes.recipeDetail.path} />
        <Route element={<IngredientsPage />} path={routes.ingredients.path} />
        <Route element={<IngredientDetailVersionPage />} path={routes.ingredientDetailVersion.path} />
        <Route element={<IngredientDetailEditPage />} path={routes.ingredientDetailEdit.path} />
        <Route element={<IngredientDetailPage />} path={routes.ingredientDetail.path} />
      </Route>
      <Route element={<VerifyEmailLinkPage />} path={routes.verifyEmailLink.path} />
      <Route element={<PhoneUploadPage />} path="/c/" />
      <Route element={<Navigate replace to={routes.landing.to()} />} path="*" />
    </Routes>
  );
};
